module.exports = __webpack_public_path__ + "static/media/multi-entry.5408dc86.svg";